


































































































































































































import "./team.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import MemberList from "../components/teams/member-list.vue";
import UserAvatar from "../components/common/user-avatar.vue";
import SimpleProgress from "../components/common/simple-progress.vue";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";
import ResizableTextarea from "../components/common/ResizableTextarea.js";
import TeamSetup from "../components/teams/team-setup.vue";
import GoalSetup from "../components/goals/goal-setup.vue";
import ProjectSetup from "../components/projects/project-setup.vue";
import ReviewSetup from "../components/reviews/review-setup.vue";
import TeamCalendar from "../components/teams/team-calendar.vue";
import AddPriority from "../components/teams/add-priority.vue";
import { on } from "iview/src/utils/dom";
import Util from "../lib/util";

export default Vue.extend({
  components: {
    MemberList,
    UserAvatar,
    SimpleProgress,
    BottomNavigation,
    BottomNavigationItem,
    ResizableTextarea,
    TeamSetup,
    GoalSetup,
    ProjectSetup,
    ReviewSetup,
    TeamCalendar,
    AddPriority,
  },
  props: {
    id: String,
  },
  data() {
    return {
      isCollapsed: false,
      mediaMatched: null,
      settingCount: 0,
      showColumnSetup: false,
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
      dynamicColumnSettings: ["name", "progress", "state"],
      dynamicColumns: [
        {
          title: "NAME",
          key: "name",
          slot: "name",
          minWidth: 200,
          className: "priority-name",
          sortable: true,
        },
        {
          title: "PROGRESS",
          key: "progress",
          slot: "progress",
          sortable: true,
          minWidth: 120,
        },
        {
          title: "USERS",
          key: "users",
          slot: "users",
          minWidth: 200,
        },
        {
          title: "TAGS",
          key: "tags",
          slot: "tags",
          minWidth: 200,
        },
        {
          title: "STATE",
          key: "state",
          slot: "state",
          sortable: true,
          minWidth: 120,
        },
      ],
      lastMenuItemName: "priorities",
      currentMenuItemName: "priorities",
      showTeamSetup: false,
      edittingTeam: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        gradeModel: null,
      },

      showProjectSetup: false,
      edittingProject: {
        id: null,
        name: null,
        color: null,
        completedPercentage: null,
        description: null,
        hashTags: null,
        completed: false,
        grantedPermissions: [],
        members: [],
        teams: [],
      },

      showGoalSetup: false,
      edittingGoal: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        gradeModel: null,
        calculationOption: NaN,
        completed: false,
        teams: [],
      },

      showReviewSetup: false,
      edittingReview: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        teamworkOption: NaN,
        editRole: NaN,
        calculationOption: NaN,
        gradingOption: NaN,
        parentRoleName: null,
        childRoleName: null,
        gradeModel: null,
        completed: false,
        teams: [],
      },
      showAddPriority: false,
    };
  },
  computed: {
    ...mapState("team", ["currentTeam", "loading"]),
    ...mapGetters("team", ["canEditCurrentTeam"]),
    ...mapState("session", ["user"]),
    columns() {
      let context = this as any;
      context.settingCount; // force recomputing

      let result: Array<any> = [
        {
          title: "TYPE",
          key: "type",
          slot: "type",
          sortable: true,
          width: 110,
          filters: [
            {
              label: "Target",
              value: "Target",
            },
            {
              label: "Project",
              value: "Project",
            },
            {
              label: "Review",
              value: "Review",
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.type === value;
          },
        },
      ];
      let settings = context.dynamicColumnSettings;
      let firstColumn = context.getDynamicColumn(settings[0]);
      firstColumn.align = "left";
      result.push(firstColumn);

      if (context.mediaMatched === false) {
        result.push(context.getDynamicColumn(settings[1]));
        result.push(context.getDynamicColumn(settings[2]));
      }
      result = result.concat([
        {
          title: "STATUS",
          slot: "status",
          width: 120,
          align: "center",
          sortable: true,
          filters: [
            {
              label: "Active",
              value: "Active",
            },
            {
              label: "Completed",
              value: "Completed",
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.status === value;
          },
        },
        {
          title: "EDIT",
          key: "memberId",
          slot: "edit",
          width: 70,
          align: "center",
        },
      ]);

      return result;
    },
    priorities() {
      let context = this as any;
      let result = [];

      if (context.currentTeam && context.currentTeam.joinedGoals && context.currentTeam.joinedGoals.length > 0) {
        result = context.currentTeam.joinedGoals.map((goal) => {
          return {
            id: goal.goalId,
            name: goal.goalName,
            type: "Target",
            progress: goal.goalResult ? Math.round(goal.goalResult * 100) : NaN,
            progressColor: goal.goalColor,
            users: goal.goalMembers,
            tags: goal.goalHashTags ? JSON.parse(goal.goalHashTags) : [],
            state: goal.goalState,
            status: goal.goalCompleted ? "Completed" : "Active",
            canEdit: goal.canEdit,
          };
        });
      }

      if (context.currentTeam && context.currentTeam.joinedProjects && context.currentTeam.joinedProjects.length > 0) {
        result = result.concat(
          context.currentTeam.joinedProjects.map((project) => {
            return {
              id: project.projectId,
              name: project.projectName,
              type: "Project",
              progress: project.projectCompletedPercentage,
              progressColor: project.projectColor,
              users: project.projectMembers,
              tags: project.projectHashTags ? JSON.parse(project.projectHashTags) : [],
              state: "All Good",
              status: project.projectCompleted ? "Completed" : "Active",
              canEdit: project.canEdit,
            };
          })
        );
      }

      if (context.currentTeam && context.currentTeam.joinedReviews && context.currentTeam.joinedReviews.length > 0) {
        result = result.concat(
          context.currentTeam.joinedReviews.map((review) => {
            return {
              id: review.reviewId,
              name: review.reviewName,
              type: "Review",
              progress: review.reviewResult ? Math.round(review.reviewResult * 100) : NaN,
              progressColor: review.reviewColor,
              users: review.reviewMembers,
              tags: review.reviewHashTags ? JSON.parse(review.reviewHashTags) : [],
              state: review.reviewState,
              status: review.reviewCompleted ? "Completed" : "Active",
              canEdit: review.canEdit,
            };
          })
        );
      }

      return result;
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    id(value) {
      this.loadTeam();
    },
    user(newValue) {
      if (newValue) {
        (this as any).selectedMemberId = newValue.id;
 
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  mounted() {
    let context = this as any;

    let abp = Util.abp;
    this.dynamicColumnSettings = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyTeamPriorityListColumns"]) : ["name", "type", "users"];

    on(window, "resize", context.onWindowResize);
    context.matchMedia();

    context.loadTeam().then(() => {
      let tab = context.$route.query.tab;
      if (tab) {
        context.handleMenuSelect(tab);
      }
    });

    abp.event.on("abp.notifications.received", context.handleNotificationReceived);
  },
  created() {
    let context = this as any;
  },
  beforeDestroy() {
    let context = this as any;
    console.log("leave page");
    abp.event.off("abp.notifications.received", context.handleNotificationReceived);
  },
  methods: {
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }

      this.mediaMatched = matchMedia("(max-width: 992px)").matches;
    },
    onWindowResize() {
      this.matchMedia();
    },
    getDynamicColumn(key) {
      let columns = this.dynamicColumns.filter((column) => {
        return column.key == key;
      });

      if (columns.length == 1) {
        return Object.assign(columns[0], { renderHeader: this.renderHeader, align: "left" });
      } else {
        return null;
      }
    },
    renderHeader(h, params) {
      let context = this as any;
      return h("span", {}, [
        h("span", params.column.title),
        h(
          "Poptip",
          {
            props: {
              value: context.showColumnSetup,
              placement: "bottom",
              transfer: true,
              width: "196px",
              trigger: "click",
              offset: 3,
              "popper-class": "ivu-table-popper",
            },
            style: {
              "font-weight": "400",
            },
            ref: "ColumnSetup",
            refInFor: true,
          },
          [
            h("Icon", {
              props: {
                type: "md-settings",
                color: "#B9BCCD",
                size: "12",
              },
              style: {
                "margin-left": "4px",
              },
            }),
            h(
              "div",
              {
                slot: "content",
                class: "", // 调整datepicker样式
              },
              [
                h(
                  "CellGroup",
                  {
                    on: {
                      "on-click": function (name) {
                        let components = context.$refs.PriorityTable.$children.filter((child) => child.$refs.ColumnSetup);
                        if (components.length == 1) {
                          components[0].$refs.ColumnSetup.forEach((poptip) => {
                            if (poptip.visible === true) {
                              poptip.handleClose();
                            }
                          });
                        }

                        let index = context.dynamicColumnSettings.indexOf(params.column.key);
                        context.dynamicColumnSettings[index] = name;
                        context.showColumnSetup = false;
                        context.settingCount++;

                        context.changeMyTeamPriorityListColumns();
                      },
                    },
                  },
                  [
                    context.dynamicColumns.map((column) => {
                      return h("Cell", {
                        props: {
                          title: column.title,
                          name: column.key,
                          selected: column.key == params.column.key,
                          disabled: column.key !== params.column.key && context.dynamicColumnSettings.indexOf(column.key) >= 0,
                        },
                        style: {
                          "text-left": "left",
                        },
                      });
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]);
    },
    changeMyTeamPriorityListColumns() {
      this.$store.dispatch("billing/changeMyTeamPriorityListColumns", { model: JSON.stringify(this.dynamicColumnSettings) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyTeamPriorityListColumns"] = JSON.stringify(this.dynamicColumnSettings);
        }
      });
    },
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      this.lastMenuItemName = name;
    },
    loadTeam() {
      let context = this as any;
      return this.$store.dispatch("team/get", { id: context.id }).then((response) => {});
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentTeam.contentVersion) {
        this.loadTeam();
      }
    },
    handleMenuItemClick(name, priority) {
      let context = this as any;
      switch (name) {
        case "open":
          if (priority.type === "Target") {
            context.handleOpenGoalEditor(priority.id);
          } else if (priority.type === "Project") {
            context.handleOpenProjectEditor(priority.id);
          } else if (priority.type === "Review") {
            context.handleOpenReviewEditor(priority.id);
          }
          break;
        case "remove":
          context.handleRemoveFromWatchlist(priority);
          break;
      }
    },
    handleDropdownMenuVisibleChange(visible) {
      console.log(visible);
    },
    handleOpenTeamEditor(team) {
      let startDate = team.startDate ? new Date(team.startDate) : null;
      let endDate = team.endDate ? new Date(team.endDate) : null;

      this.edittingTeam = {
        id: team.id,
        name: team.name,
        scope: team.scope,
        timezoneOffset: team.timezoneOffset,
        timezoneName: team.timezoneName,
        timeline: [startDate, endDate],
        description: team.description,
        members: team.members,
        hashTags: team.hashTags,
        grantedPermissions: team.grantedPermissions,
        gradeModel: team.gradeModel,
      };

      this.showTeamSetup = true;
    },
    handleCancelNewTeam() {
      this.showTeamSetup = false;
    },
    handleValueFormatChanged(valueFormat) {
      var context = this as any;
      context.reportCardValueFormat = valueFormat;
    },
    handleOpenGoalEditor(goalId) {
      return this.$store.dispatch("goal/get", { id: goalId }).then((goal) => {
        let startDate = goal.startDate ? new Date(goal.startDate) : null;
        let endDate = goal.endDate ? new Date(goal.endDate) : null;

        this.edittingGoal = {
          id: goal.id,
          name: goal.name,
          scope: goal.scope,
          timezoneOffset: goal.timezoneOffset,
          timezoneName: goal.timezoneName,
          timeline: [startDate, endDate],
          description: goal.description,
          members: goal.members,
          hashTags: goal.hashTags,
          grantedPermissions: goal.grantedPermissions,
          gradeModel: goal.gradeModel,
          calculationOption: goal.calculationOption,
          completed: goal.completed,
          teams: goal.teams,
        };

        this.showGoalSetup = true;
      });
    },
    handleOpenProjectEditor(projectId) {
      return this.$store.dispatch("project/get", { id: projectId }).then((project) => {
        this.edittingProject = {
          id: project.id,
          name: project.name,
          color: project.color,
          completedPercentage: project.completedPercentage,
          description: project.description,
          hashTags: project.hashTags,
          completed: project.completed,
          grantedPermissions: project.grantedPermissions,
          members: project.members,
          teams: project.teams,
        };

        this.showProjectSetup = true;
      });
    },
    handleOpenReviewEditor(reviewId) {
      return this.$store.dispatch("review/get", { id: reviewId }).then((review) => {
        let startDate = review.startDate ? new Date(review.startDate) : null;
        let endDate = review.endDate ? new Date(review.endDate) : null;

        this.edittingReview = {
          id: review.id,
          name: review.name,
          scope: review.scope,
          timezoneOffset: review.timezoneOffset,
          timezoneName: review.timezoneName,
          timeline: [startDate, endDate],
          description: review.description,
          members: review.members,
          hashTags: review.hashTags,
          teamworkOption: review.teamworkOption,
          editRole: review.editRole,
          calculationOption: review.calculationOption,
          gradingOption: review.gradingOption,
          parentRoleName: review.parentRoleName,
          childRoleName: review.childRoleName,
          grantedPermissions: review.grantedPermissions,
          gradeModel: review.gradeModel,
          completed: review.completed,
          teams: review.teams,
        };

        this.showReviewSetup = true;
      });
    },
    handleRemoveFromWatchlist(priority) {
      let context = this as any;
      let actionName = "";
      let data = {};
      if (priority.type === "Target") {
        actionName = "goal/removeTeam";
        data = {
          goalId: priority.id,
          teamId: context.currentTeam.id,
        };
      } else if (priority.type === "Project") {
        actionName = "project/removeTeam";
        data = {
          projectId: priority.id,
          teamId: context.currentTeam.id,
        };
      } else if (priority.type === "Review") {
        actionName = "review/removeTeam";
        data = {
          reviewId: priority.id,
          teamId: context.currentTeam.id,
        };
      }

      context.$store
        .dispatch(actionName, {
          data: data,
        })
        .then(() => {
          context.loadTeam();
          context.$Notice.success({
            title: "Remove priority",
            desc: "Success! ",
          });
        });
    },
  },
});
